import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

interface ForbiddenModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const ForbiddenModal = ({ isOpen, message, onClose }: ForbiddenModalProps) => {
  const handleOk = () => {
    // Clear all localStorage data
    localStorage.clear();
    
    // Close modal and redirect to login
    onClose();
    
    // Redirect to login page
    window.location.href = "/login";
  };

  return (
    <>
      {/* Blur overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" />
      )}
      
      <Dialog open={isOpen} onOpenChange={() => {}}>
        <DialogContent className="sm:max-w-md z-50">
          <DialogHeader>
            <div className="flex items-center gap-3 mb-2">
              <div className="flex-shrink-0 w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
              </div>
              <div>
                <DialogTitle className="text-xl font-semibold text-slate-900 dark:text-slate-100">
                  Access Forbidden
                </DialogTitle>
                <DialogDescription className="text-slate-600 dark:text-slate-400">
                  You don't have permission to access this resource
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>

          <div className="space-y-4">
            <div className="bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg p-4">
              <h4 className="text-sm font-medium text-red-800 dark:text-red-200 mb-2">
                Server Response:
              </h4>
              <p className="text-sm text-red-700 dark:text-red-300 break-words">
                {message || "Access denied. Please contact your administrator."}
              </p>
            </div>

            <div className="bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
              <p className="text-sm text-amber-800 dark:text-amber-200">
                <strong>Note:</strong> You will be redirected to the login page when you click OK.
              </p>
            </div>

            <Button
              onClick={handleOk}
              className="w-full bg-gray-600 hover:bg-gray-700 dark:bg-gray-600 dark:hover:bg-gray-700 text-white"
            >
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ForbiddenModal;
